import SectionHeading from "./SectionHeading";
import { categories } from "@/mocks/categories";

interface CategoryNavProps {
  onOpenCategory: (id: string) => void;
}

const tints = [
  "bg-accent-100 text-accent-700",
  "bg-primary-100 text-primary-700",
  "bg-secondary-200 text-secondary-800",
  "bg-accent-100 text-accent-700",
  "bg-primary-100 text-primary-700",
  "bg-secondary-200 text-secondary-800",
];

export default function CategoryNav({ onOpenCategory }: CategoryNavProps) {
  return (
    <section id="category" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            eyebrow="Browse by Topic"
            title="按分类找瓜，想看的都在这"
            desc="六大主题清晰分区，娱乐八卦、明星爆料、社会事件、网红日常、搞笑合集、实拍现场，点进去直接看对应内容。"
          />
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => (
            <button
              key={c.id}
              onClick={() => onOpenCategory(c.id)}
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-100/60 p-6 text-left transition-all hover:-translate-y-0.5 hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <span className={`flex h-12 w-12 items-center justify-center rounded-xl text-xl ${tints[i % tints.length]}`}>
                  <i className={c.icon}></i>
                </span>
                <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-semibold text-secondary-800">
                  {c.count.toLocaleString()} 条
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-extrabold text-foreground-950">{c.name}</h3>
              <p className="text-xs font-medium text-primary-600">{c.tagline}</p>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{c.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-foreground-500 transition-colors group-hover:text-primary-600">
                进入该分类
                <i className="ri-arrow-right-line"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}